export default {
    "title": "Provider",
    "entityName": "provider",
    "pagination": {
        "rowsPerPage": 5,
        "page": 1,
        "sortBy": "id",
        "descending": true
    },
    "fields": [
        {
            "value": "name",
            "text": "Name",
            "type": "text",
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required"
            ]
        },
        {
            "value": "address",
            "text": "Address",
            "type": "text",
            "table": {
                "sortable": true    
            },
            render: item => `${item.address}, ${item.city}, ${item.cap} (${item.country})`,
            "validators": [
                "required"
            ]
        },
        {
            "value": "cap",
            "text": "Cap",
            "type": "text",
            "validators": [
                "required"
            ]
        },
        {
            "value": "city",
            "text": "City",
            "type": "text",
            "validators": [
                "required"
            ]
        },
        {
            "value": "country",
            "text": "Country",
            "type": "text",
            "validators": [
                "required",
                (field, value) => value && value.length <= 2 || `Country max. length is 2`
            ]
        },
        {
            "value": "email",
            "text": "Email",
            "type": "text",
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required",
                "email"
            ]
        }        
    ],
    "actions": [
        "upsert", "remove",
        { "value": "references", "text": "References", "color": "primary", "icon": "mdi-contacts" }, 'audit'
    ]
}